<template>
  <div class="card">
    <div class="card-body">
      <div
        v-if="carregando"
        class="veh-carregando"
      >
        <div class="veh-esqueleto-topo">
          <div class="veh-esqueleto veh-esqueleto--avatar" />
          <div class="veh-esqueleto-linhas">
            <div class="veh-esqueleto veh-esqueleto--titulo" />
            <div class="veh-esqueleto veh-esqueleto--legenda" />
          </div>
        </div>
        <div class="row veh-grupos">
          <div
            v-for="n in 4"
            :key="n"
            class="col-12 col-md-6 col-xl-3 veh-grupo"
          >
            <div class="veh-painel">
              <div class="veh-esqueleto veh-esqueleto--rotulo" />
              <div
                v-for="linha in 3"
                :key="linha"
                class="veh-esqueleto veh-esqueleto--campo"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        v-else
        class="veh-topo"
      >
        <div class="veh-identidade">
          <div class="veh-identidade-texto">
            <h3 class="veh-nome">{{ nomeExibido || '—' }}</h3>
            <div class="veh-marcas">
              <span class="veh-placa">{{ vehicleData.license_plate || $t('N/A') }}</span>
              <span
                v-if="vehicleData.vehicleType"
                class="veh-tag"
              >{{ vehicleData.vehicleType }}</span>
              <span
                v-if="vehicleData.sigla"
                class="veh-tag"
              >{{ vehicleData.sigla }}</span>
            </div>
            <div class="veh-meta">
              <div v-if="central">
                <IconeCentral />
                <span>{{ central }}</span>
              </div>
              <div v-if="unidade">
                <IconeUnidade />
                <span>{{ unidade }}</span>
              </div>
              <div v-if="periodoAtribuicao">
                <feather-icon icon="CalendarIcon" size="14" />
                <span>{{ periodoAtribuicao }}</span>
              </div>
              <div :class="`veh-manutencao veh-manutencao--${manutencao.estado}`">
                <feather-icon icon="ToolIcon" size="14" />
                <span>{{ $t('maintenance_next_date') }}: {{ manutencao.texto }}</span>
                <span
                  v-if="manutencao.estado === 'vencida'"
                  class="veh-selo veh-selo--alerta"
                >{{ $t('Overdue') }}</span>
                <span
                  v-else-if="manutencao.estado === 'proxima'"
                  class="veh-selo veh-selo--aviso"
                >{{ manutencao.dias }} {{ $t('days') }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="veh-acoes-topo">
            <div class="veh-acoes">
              <b-button
                size="sm"
                variant="outline-primary"
                @click="$emit('edit-assignment')"
              >
                {{ $t('Edit Assignment') }}
              </b-button>
              <b-button
                v-if="vehicleData.doc_vehicle_url"
                size="sm"
                variant="outline-secondary"
                :href="vehicleData.doc_vehicle_url"
                download
                target="_blank"
              >
                {{ $t('CRLV') }} <i class="fa fa-download" />
              </b-button>
            </div>
        </div>
      </div>

      <div
        v-if="!carregando"
        class="row veh-grupos"
      >
        <div
          v-for="grupo in grupos"
          :key="grupo.titulo"
          class="col-12 col-md-6 col-xl-3 veh-grupo"
        >
          <div class="veh-painel">
            <h6 class="veh-grupo-titulo">{{ grupo.titulo }}</h6>
            <dl class="veh-lista">
            <template v-for="campo in grupo.campos">
              <dt
                :key="campo.rotulo + '-r'"
                class="veh-rotulo"
              >{{ campo.rotulo }}</dt>
              <dd
                :key="campo.rotulo + '-v'"
                class="veh-valor"
                :class="{ 'veh-vazio': !campo.valor }"
              >{{ campo.valor || '—' }}</dd>
              </template>
            </dl>
          </div>
        </div>
      </div>

      <div
        v-if="!carregando && historicoAtribuicoes.length"
        class="veh-historico"
      >
        <div class="veh-historico-cabecalho">
          <h6 class="veh-grupo-titulo mb-0">{{ $t('Assignment History') }}</h6>
          <b-button
            v-if="atribuicoesOcultas > 0"
            size="sm"
            variant="link"
            class="p-0"
            @click="verTodasAtribuicoes = !verTodasAtribuicoes"
          >
            {{ verTodasAtribuicoes ? $t('Show less') : `${$t('Show all')} (${atribuicoesOcultas})` }}
          </b-button>
        </div>

        <ul class="veh-linha-tempo">
          <li
            v-for="item in historicoAtribuicoes"
            :key="item.id"
            class="veh-linha-item"
            :class="{ 'veh-linha-item--ativa': ehAtiva(item) }"
          >
            <div class="veh-linha-marca" />
            <div class="veh-linha-corpo">
              <div class="veh-linha-topo">
                <span class="veh-linha-nome">{{ item.name || '—' }}</span>
                <span
                  class="veh-linha-status"
                  :class="ehAtiva(item) ? 'veh-linha-status--ativa' : ''"
                >{{ ehAtiva(item) ? $t('Active') : $t('Finished') }}</span>
              </div>
              <div class="veh-linha-datas">
                {{ periodoDe(item) }}
              </div>
              <div class="veh-meta veh-meta--compacta">
                <div v-if="item.center && item.center.name">
                  <IconeCentral />
                  <span>{{ item.center.name }}</span>
                </div>
                <div v-if="item.unit && item.unit.name">
                  <IconeUnidade />
                  <span>{{ item.unit.name }}</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

   

    <!-- Desativado: bateria, SIM card e dispositivo nao estao em uso -->
    <div v-if="false" class="card-footer row">
      <!-- Card de Bateria -->
      <div class="col-12 col-md-4">
        <div class="card text-center shadow-sm mb-4">
          <BatteryComponent :backBattery="getBackBattery"  :mainBattery="getMainBatteryDec" />

        </div>
      </div>

      <!-- Card de Chip -->
      <div class="col-12 col-md-4">
        <div class="card text-center shadow-sm mb-4">
          <div class="card-body">
            <h5 class="card-title mb-3">{{ $t('Chip') }}</h5>
            <div class="card-text mt-1">
              <div class="row">
                <div class="col-6 text-right">
                  <i class="fas fa-satellite  mt-n1 text-primary" style="font-size: 30px;"></i>
                </div>
                <div class="col-6 text-left">

                  <span class="d-block ">{{ vehicleData.deviceActivation.telephone || $t('Without Chip') }}</span>
                </div>

              </div>
              <div class="row mt-2">
                <div class="col-6 text-right">
                  <i class="fas fa-phone  mt-n1 text-primary" style="font-size: 30px;"></i>
                </div>
<!--                <div class="col-6 text-left">-->

<!--                  <span class="d-block ">{{ vehicleData.telephone_pulsos || $t('No phone') }}</span>-->
<!--                </div>-->

              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Card de Dispositivo -->
      <div class="col-12 col-md-4">
        <div class="card text-center shadow-sm ">
          <div class="card-body">
            <h5 class="card-title">{{ $t('Device') }}</h5>
            <div class="card-text">
              <b-button
                class="mr-1"
                pill
                variant="primary"
                @click="$emit('showDeviceActivations', !modalShow)"
              >
                Ver
              </b-button>

                 <b-button
                   v-if="vehicleData.deviceActivation.status === 1"
                   class="ml-2 no-border"
                   pill
                   variant="outline-primary"
                   @click="$emit('showDeviceActivationsConfig', !modalConfigShow)"
                 >
                   <i class="fa fa-cogs fa-2x"></i>
                 </b-button>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BatteryComponent from './BatteryComponent'

const tracoFeather = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  'stroke-width': '2',
  'stroke-linecap': 'round',
  'stroke-linejoin': 'round',
}

const IconeCentral = {
  name: 'IconeCentral',
  functional: true,
  render(h, { data }) {
    return h('svg', { ...data, attrs: { ...tracoFeather, ...data.attrs } }, [
      h('path', { attrs: { d: 'M3 21h18' } }),
      h('path', { attrs: { d: 'M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16' } }),
      h('path', { attrs: { d: 'M9 7h2M13 7h2M9 11h2M13 11h2M9 15h2M13 15h2' } }),
    ])
  },
}

const IconeUnidade = {
  name: 'IconeUnidade',
  functional: true,
  render(h, { data }) {
    return h('svg', { ...data, attrs: { ...tracoFeather, ...data.attrs } }, [
      h('path', { attrs: { d: 'M3 21h18' } }),
      h('path', { attrs: { d: 'M5 21V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14' } }),
      h('path', { attrs: { d: 'M12 10v6' } }),
      h('path', { attrs: { d: 'M9 13h6' } }),
    ])
  },
}

export default {
  props: {
    vehicleData: {
      type: Object,
      required: true,
    },
    activeAssignment: {
      type: Object,
      default: null,
    },
    carregando: {
      type: Boolean,
      default: false,
    },
    assignments: {
      type: Array,
      default: () => [],
    },
    totalAssignments: {
      type: Number,
      default: 0,
    },
    modalShow: {
      type: Boolean,
      default: false,
    },
    modalConfigShow: {
      type: Boolean,
      default: false,
    },
    backBattery: {
      type: [Number, String],
      default: 0,
    },
    mainBatteryDec: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      verTodasAtribuicoes: false,
    };
  },
  computed: {
    nomeExibido() {
      const atribuicao = this.activeAssignment && this.activeAssignment.name
      return atribuicao || this.vehicleData.vehicle
    },
    anoFabricacaoModelo() {
      const fabricacao = this.vehicleData.manufacture_year
      const modelo = this.vehicleData.model_year

      if (fabricacao && modelo) {
        return `${fabricacao} / ${modelo}`
      }

      return fabricacao || modelo || null
    },
    periodoAtribuicao() {
      const a = this.activeAssignment

      if (!a || !a.start_date) {
        return null
      }

      const inicio = this.formatDate(a.start_date)

      return a.end_date
        ? `${inicio} até ${this.formatDate(a.end_date)}`
        : `Desde ${inicio}`
    },
    historicoAtribuicoes() {
      const lista = Array.isArray(this.assignments) ? this.assignments.slice() : []

      lista.sort((x, y) => String(y.start_date || '').localeCompare(String(x.start_date || '')))

      return this.verTodasAtribuicoes ? lista : lista.slice(0, 5)
    },
    atribuicoesOcultas() {
      const total = Array.isArray(this.assignments) ? this.assignments.length : 0

      return Math.max(total - 5, 0)
    },
    central() {
      const a = this.activeAssignment

      return (a && a.center && a.center.name) || this.vehicleData.center || null
    },
    unidade() {
      const a = this.activeAssignment

      return (a && a.unit && a.unit.name) || this.vehicleData.unit || null
    },
    manutencao() {
      const lista = this.vehicleData.maintenances

      if (!lista || !lista.length) {
        return { texto: this.$t('Not scheduled'), estado: 'ausente' }
      }

      const bruto = lista[lista.length - 1].maintenance_next_date
      const data = new Date(bruto)

      if (Number.isNaN(data.getTime())) {
        return { texto: this.$t('Not scheduled'), estado: 'ausente' }
      }

      const hoje = new Date()
      hoje.setHours(0, 0, 0, 0)
      const dias = Math.round((data - hoje) / 86400000)

      let estado = 'normal'
      if (dias < 0) {
        estado = 'vencida'
      } else if (dias <= 15) {
        estado = 'proxima'
      }

      return { texto: data.toLocaleDateString('pt-BR'), estado, dias }
    },
    grupos() {
      const d = this.vehicleData || {}
      const a = this.activeAssignment

      return [
        {
          titulo: this.$t('Operation'),
          campos: [
            { rotulo: this.$t('Central'), valor: (a && a.center && a.center.name) || d.center },
            { rotulo: this.$t('Unit'), valor: (a && a.unit && a.unit.name) || d.unit },
            { rotulo: this.$t('Assignment'), valor: (a && a.name) || d.vehicle },
          ],
        },
        {
          titulo: this.$t('Identification'),
          campos: [
            { rotulo: this.$t('Acronym'), valor: d.sigla },
            { rotulo: this.$t('Vehicle Type'), valor: d.vehicleType },
            { rotulo: this.$t('Specialty'), valor: d.specialty },
          ],
        },
        {
          titulo: this.$t('Documentation'),
          campos: [
            { rotulo: this.$t('Frame'), valor: d.frame },
            { rotulo: this.$t('National car registration'), valor: d.national_registry },
            { rotulo: this.$t('Tracking Token'), valor: d.tracking_token },
          ],
        },
        {
          titulo: this.$t('Vehicle'),
          campos: [
            { rotulo: this.$t('Vehicle Brand'), valor: d.vehicle_brand },
            { rotulo: this.$t('Vehicle Model'), valor: d.vehicle_model },
            { rotulo: this.$t('Vehicle Colors'), valor: d.vehicle_color },
            { rotulo: this.$t('Year'), valor: this.anoFabricacaoModelo },
          ],
        },
      ]
    },
    getBackBattery() {
      return this.backBattery > 10 ? (this.backBattery / 10).toFixed(1) : this.backBattery;
    },
    getMainBatteryDec() {
      return this.mainBatteryDec > 100 ? (this.mainBatteryDec / 10).toFixed(1) : this.mainBatteryDec;
    },
    normalizedDevices() {
      const list = Array.isArray(this.vehicleData.deviceAssignment) ? this.vehicleData.deviceAssignment : [];
      if (!list.length) return [];
      return list.map(item => {
        const node = item && (item.device || item);
        const imei = node?.imei || node?.serial_number || node?.identifier || node?.id || node?.device_id;
        const desc = node?.description || node?.name || node?.device_model?.name || node?.model || node?.type;
        if (imei && desc) return `${imei} - ${desc}`;
        if (imei) return String(imei);
        if (desc) return desc;
        return '-';
      }).filter(Boolean);
    }
  },
  methods: {
    ehAtiva(item) {
      return item && (item.status === 'active' || !item.end_date)
    },
    periodoDe(item) {
      if (!item || !item.start_date) {
        return '—'
      }

      const inicio = this.formatDate(item.start_date)

      return item.end_date ? `${inicio} — ${this.formatDate(item.end_date)}` : `${inicio} — em aberto`
    },
    formatDate(date) {
      if (date) {
        return new Date(date).toLocaleDateString('pt-BR');
      }
      return '';
    },
  },
  components: {
    BatteryComponent,
    IconeCentral,
    IconeUnidade,
  }
};
</script>

<style scoped>
.veh-topo {
  display: flex;
  flex-wrap: wrap;
  gap: 1.25rem;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1.5rem;
  margin-bottom: 1.75rem;
  border-bottom: 1px solid rgba(34, 41, 47, 0.08);
}

.veh-identidade {
  display: flex;
  align-items: center;
  gap: 1.25rem;
  min-width: 0;
}

.veh-identidade-texto {
  min-width: 0;
}

.veh-avatar {
  position: relative;
  flex-shrink: 0;
}

.veh-sinal {
  position: absolute;
  right: -2px;
  bottom: -2px;
  box-shadow: 0 0 0 3px #fff;
}

.veh-nome {
  margin: 0 0 0.5rem;
  font-weight: 600;
  line-height: 1.15;
  word-break: break-word;
}

.veh-marcas {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  align-items: center;
}

.veh-placa {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  padding: 0.2rem 0.55rem;
  border: 1px solid rgba(34, 41, 47, 0.2);
  border-radius: 4px;
}

.veh-tag {
  font-size: 0.78rem;
  padding: 0.22rem 0.6rem;
  border-radius: 999px;
  background: rgba(34, 41, 47, 0.06);
}

.veh-acoes-topo {
  margin-left: auto;
}

.veh-acoes {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.veh-grupos {
  row-gap: 1rem;
}

.veh-grupo {
  display: flex;
}

.veh-painel {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: rgba(34, 41, 47, 0.025);
  border: 1px solid rgba(34, 41, 47, 0.06);
  border-radius: 10px;
  padding: 1.1rem 1.25rem 1.25rem;
}

.veh-grupo-titulo {
  font-size: 0.68rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  opacity: 0.45;
  margin-bottom: 1rem;
}

.veh-lista {
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.veh-rotulo {
  font-size: 0.72rem;
  font-weight: 400;
  opacity: 0.55;
  margin: 0 0 0.1rem;
  line-height: 1.3;
}

.veh-valor {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.3;
  word-break: break-word;
}

.veh-vazio {
  font-weight: 400;
  opacity: 0.3;
}

.veh-carregando {
  padding-bottom: 0.5rem;
}

.veh-esqueleto-topo {
  display: flex;
  align-items: center;
  gap: 1.25rem;
  padding-bottom: 1.5rem;
  margin-bottom: 1.75rem;
  border-bottom: 1px solid rgba(34, 41, 47, 0.08);
}

.veh-esqueleto-linhas {
  flex: 1;
  max-width: 22rem;
}

.veh-esqueleto {
  background: linear-gradient(
    90deg,
    rgba(34, 41, 47, 0.06) 25%,
    rgba(34, 41, 47, 0.11) 37%,
    rgba(34, 41, 47, 0.06) 63%
  );
  background-size: 400% 100%;
  border-radius: 6px;
}

@media (prefers-reduced-motion: no-preference) {
  .veh-esqueleto {
    animation: veh-brilho 1.4s ease-in-out infinite;
  }
}

@keyframes veh-brilho {
  from { background-position: 100% 50%; }
  to { background-position: 0 50%; }
}

.veh-esqueleto--avatar {
  width: 5.5rem;
  height: 5.5rem;
  border-radius: 50%;
  flex-shrink: 0;
}

.veh-esqueleto--titulo {
  height: 1.5rem;
  width: 70%;
  margin-bottom: 0.6rem;
}

.veh-esqueleto--legenda {
  height: 1rem;
  width: 40%;
}

.veh-esqueleto--rotulo {
  height: 0.7rem;
  width: 45%;
  margin-bottom: 1.1rem;
}

.veh-esqueleto--campo {
  height: 2.4rem;
  margin-bottom: 0.85rem;
}

.veh-esqueleto--campo:last-child {
  margin-bottom: 0;
}

.veh-meta {
  margin-top: 0.7rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.85rem;
  opacity: 0.65;
}

.veh-meta > div {
  display: flex;
  align-items: center;
  gap: 0.45rem;
}

.veh-meta svg {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  opacity: 0.75;
}

.veh-meta--compacta svg {
  width: 12px;
  height: 12px;
}

.veh-manutencao--vencida {
  color: #ea5455;
  opacity: 1;
}

.veh-manutencao--proxima {
  color: #b8791a;
  opacity: 1;
}

.veh-selo {
  font-size: 0.66rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 0.05rem 0.4rem;
  border-radius: 999px;
  font-weight: 600;
}

.veh-selo--alerta {
  background: rgba(234, 84, 85, 0.14);
}

.veh-selo--aviso {
  background: rgba(184, 121, 26, 0.14);
}

.veh-meta--compacta {
  margin-top: 0.2rem;
  font-size: 0.8rem;
  opacity: 0.5;
  gap: 0.1rem;
}

.veh-historico {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(34, 41, 47, 0.08);
}

.veh-historico-cabecalho {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.1rem;
}

.veh-linha-tempo {
  list-style: none;
  margin: 0;
  padding: 0 0 0 1.1rem;
  position: relative;
}

.veh-linha-tempo::before {
  content: '';
  position: absolute;
  left: 4px;
  top: 0.45rem;
  bottom: 0.45rem;
  width: 1px;
  background: rgba(34, 41, 47, 0.12);
}

.veh-linha-item {
  position: relative;
  padding-bottom: 1.1rem;
}

.veh-linha-item:last-child {
  padding-bottom: 0;
}

.veh-linha-marca {
  position: absolute;
  left: -1.1rem;
  top: 0.35rem;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #fff;
  border: 2px solid rgba(34, 41, 47, 0.25);
}

.veh-linha-item--ativa .veh-linha-marca {
  border-color: #28c76f;
  background: #28c76f;
}

.veh-linha-topo {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.5rem;
}

.veh-linha-nome {
  font-weight: 600;
}

.veh-linha-status {
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  padding: 0.1rem 0.45rem;
  border-radius: 999px;
  background: rgba(34, 41, 47, 0.07);
  opacity: 0.7;
}

.veh-linha-status--ativa {
  background: rgba(40, 199, 111, 0.14);
  color: #1f9254;
  opacity: 1;
}

.veh-linha-datas {
  font-size: 0.83rem;
  opacity: 0.65;
  margin-top: 0.15rem;
}

.veh-secao-titulo {
  font-size: 0.68rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  opacity: 0.45;
  margin-bottom: 1rem;
}

.no-border {
  border: none !important;
  box-shadow: none !important;
}
</style>
